<template>
    <div>
        <Companies/>
    </div>
</template>
<script>
    import Companies from '@/components/companies/Companies';

    export default {
        name: 'admin-flow',
        components: {
            Companies,
        }
    }
</script>